import Modal from './Modal';
import cookieInstance from './Cookie';
function resizeActive() {
  var classes = document.body.classList;
  var navbarToggler = document.querySelector('.header .navbar-toggler');
  var breakpoint = 1024;
  var mobileMenuClass = 'nav-active';
  var timer = 0;
  window.addEventListener('resize', function () {
    if (window.innerWidth >= breakpoint) {
      classes.remove(mobileMenuClass);
      navbarToggler.classList.remove('active');
      return;
    }
    if (timer) {
      clearTimeout(timer);
      timer = null;
    } else {
      classes.add('stop-transitions');
    }
    timer = setTimeout(function () {
      classes.remove('stop-transitions');
      timer = null;
    }, 100);
  });
}
function headerToggler() {
  var body = document.querySelector('body');
  var toggler = document.querySelectorAll('.header .navbar-toggler');
  if (!toggler) return;
  toggler.forEach(function (item) {
    item.addEventListener('click', function (e) {
      e.preventDefault();
      body.classList.toggle('nav-active');
      this.classList.toggle('active');
    });
  });
}
function accordion() {
  var accordions = document.querySelectorAll('.js-accordion');
  if (!accordion) return;
  var openerCls = '.js-accordion-opener';
  var bodyCls = '.js-accordion-body';
  var active = 'active';
  accordions.forEach(function (accordion) {
    var $opener = accordion.querySelector(openerCls);
    var $body = accordion.querySelector(bodyCls);
    if (!$opener && !$body) return;
    $opener.addEventListener('click', function (e) {
      e.preventDefault();
      if (accordion.classList.contains(active)) {
        accordion.classList.remove(active);
        jQuery($body).slideUp();
      } else {
        accordion.classList.add(active);
        jQuery($body).slideDown();
      }
    });
  });
}
function filterToggler() {
  var filterContainer = document.querySelector('.js-filter-panel-container');
  if (!filterContainer) return;
  var togglerFilter = filterContainer.querySelector('.js-filter-toggler');
  var togglerFilterText = togglerFilter.querySelector('.filter-toggler__text');
  var filtersWrapper = filterContainer.querySelector('.js-filter-products-wrapper');
  var activeToggleFilterText = togglerFilterText.innerText;
  var inActiveToggleFilterText = 'Hide filter';
  var activeToggleCls = 'active';
  togglerFilter.addEventListener('click', function (e) {
    e.preventDefault();
    handleClickFilterToggler.bind(this)();
  });
  function handleClickFilterToggler() {
    this.classList.toggle(activeToggleCls);
    this.classList.contains(activeToggleCls) ? togglerFilterText.innerText = inActiveToggleFilterText : togglerFilterText.innerText = activeToggleFilterText;
    if (filtersWrapper) {
      jQuery(filtersWrapper).slideToggle();
    }
  }
}
function autoComplete() {
  var modalObj = new Modal({
    container: '.js-modal-country',
    modalOverlayCls: 'js-modal-country-overlay',
    btnCloseModal: '.js-modal-country-close'
  });
  var cookieData = {
    name: 'country',
    value: null,
    days: 30
  };
  if (typeof cookieInstance.getCookie(cookieData.name) === 'undefined') {
    modalObj.openModal();
  }
  var container = document.querySelector('.js-autocomplete');
  if (!container) return;
  var placeholderBtn = container.querySelector('.js-autocomplete-placeholder');
  var autocompleteBody = container.querySelector('.js-autocomplete-body');
  var input = container.querySelector('.js-autocomplete-input');
  var list = container.querySelector('.js-autocomplete-list');
  var linkSelector = container.querySelectorAll('.js-autocomplete-link');
  placeholderBtn.addEventListener('click', function (e) {
    this.classList.add('hidden');
    autocompleteBody.classList.remove('hidden');
  });
  input.addEventListener('input', function (e) {
    var value = e.target.value.toLowerCase();
    linkSelector.forEach(function (link) {
      if (link.innerText.toLowerCase().includes(value)) {
        link.parentNode.classList.remove('hidden');
      } else {
        link.parentNode.classList.add('hidden');
      }
    });
  });
  linkSelector.forEach(function (link) {
    link.addEventListener('click', function (e) {
      e.preventDefault();
      input.value = e.target.innerText;
      list.classList.add('hidden');
      cookieData.value = e.target.dataset.country;
      cookieInstance.setCookie(cookieData);
      window.location.reload();
      modalObj.closeModal();
    });
  });
}
function cookiesPolicy() {
  var $cookies = document.querySelector('.js-cookies-policy');
  if (!$cookies) return;
  var cookieData = {
    name: 'gardeco-cookies',
    value: 'true',
    days: 30
  };
  if (typeof cookieInstance.getCookie(cookieData.name) === 'undefined') {
    $cookies.classList.remove('hidden');
  } else {
    $cookies.parentNode.removeChild($cookies);
  }
  var btnSave = $cookies.querySelector('.js-cookies-policy-button');
  btnSave.addEventListener('click', function (e) {
    e.preventDefault();
    cookieInstance.setCookie(cookieData);
    $cookies.parentNode.removeChild($cookies);
  });
}
function smoothScroll() {
  $('a.js-smooth-scroll').on('click', function (event) {
    if (this.hash !== "") {
      event.preventDefault();
      var hash = this.hash;
      $('html, body').animate({
        scrollTop: $(hash).offset().top
      }, 300, function () {
        window.location.hash = hash;
      });
    }
  });
}
export default function common() {
  cookiesPolicy();
  resizeActive();
  headerToggler();
  accordion();
  filterToggler();
  autoComplete();
  smoothScroll();
}